import { sortArrayBy } from '@domain-group/javascript-utils'

import type { ProviderPriceListModel, ServiceProductModel } from '@models/types'
import { EntitiesState } from '@redux/entities'

type FilterPriceListItemsByPriceListAndProductParams = {
  providerPriceList: ProviderPriceListModel | {},
  providerPriceListItems: EntitiesState['providerPriceListItems'],
  serviceProduct: ServiceProductModel,
}

const filterPriceListItemsByPriceListAndProduct = (params: FilterPriceListItemsByPriceListAndProductParams) => {
  const { providerPriceList, providerPriceListItems, serviceProduct } = params

  // @ts-expect-error TS2339
  if (!providerPriceList?.id || !serviceProduct?.id){
    return []
  }

  const filtered = Object.values(providerPriceListItems)
    .filter((providerPriceListItem) => {
      const { hidden, provider_price_list_id, service_product_id } = providerPriceListItem

      return !hidden
        // @ts-expect-error TS2339
        && providerPriceList.id === provider_price_list_id
        && serviceProduct.id === service_product_id
    })

  const sorted = sortArrayBy(filtered, 'asc', 'quantity')

  return sorted
}

export default filterPriceListItemsByPriceListAndProduct
